import { useState } from 'react'

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'

interface EmploymentHistoryProps {
  user_experience:
    | {
        title: string | undefined
        company_name: string | undefined
        employment_type: string | undefined
        date: string | undefined
        location: string | undefined
        location_type: string | undefined
      }[]
    | undefined
}
export function EmploymentHistory(props: EmploymentHistoryProps) {
  const { user_experience } = props
  const [show, setShow] = useState<boolean>(true)
  const idAccordion = 'employment-history'
  return (
    <>
      <Accordion
        defaultValue={idAccordion}
        type="single"
        collapsible
        className="w-full rounded-md border-t-4 border-t-[#D91F2E] bg-white"
        onValueChange={(value) => setShow(value === idAccordion)}
      >
        <AccordionItem value={idAccordion} className="border-none p-0">
          <AccordionTrigger className="border-b border-b-[#EAECF0] p-6">
            <div className="flex w-full items-center justify-between">
              <div>Riwayat Pekerjaan</div>
              <div className="text-xs">{show ? 'Sembunyikan' : ''}</div>
            </div>
          </AccordionTrigger>
          <AccordionContent className="w-full">
            {user_experience?.length == 0 ? (
              <div className="flex justify-center p-4">Tidak ada data</div>
            ) : (
              <></>
            )}
            <div className="flex w-full flex-col gap-4 divide-y">
              {user_experience?.map((t, key) => (
                <div className="grid w-full grid-cols-4 gap-4 p-6">
                  <div className="flex flex-col">
                    <div className="font-semibold">Jabatan</div>
                    <div>{t.title}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Nama Perusahaan</div>
                    <div>{t.company_name}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Status Karyawan</div>
                    <div>{t.employment_type}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Tanggal Mulai - Selesai</div>
                    <div>{t.date}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Lokasi Pekerjaan</div>
                    <div>{t.location}</div>
                  </div>
                  <div className="flex flex-col">
                    <div className="font-semibold">Tipe Lokasi</div>
                    <div>{t.location_type}</div>
                  </div>
                </div>
              ))}
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </>
  )
}
